<ng-container *ngIf="!showExport">
  <payarc-page-header title="Customers">
    <button type="button" payarcButton="primary" *ngIf="create_permission && !isPaypalMerchant" (click)="addNew()">+ New</button>
  </payarc-page-header>

  <payarc-filter-bar class="cl-filter-row">
    <payarc-search placeholder="Search" [value]="searchText || ''" (valueChange)="onSearch($event)"></payarc-search>
    <div class="pa-row pa-gap-8">
      <span id="customerDateRangeLabel">Date range</span>
      <input type="text" class="pa-input" aria-labelledby="customerDateRangeLabel" aria-label="From date"
             [matDatepicker]="dp" [max]="today" placeholder="From" (click)="dp.open()" [(ngModel)]="from_date" (dateChange)="checkdate()" readonly />
      <mat-datepicker #dp (closed)="datereport()"></mat-datepicker>
      <input type="text" class="pa-input" aria-labelledby="customerDateRangeLabel" aria-label="To date"
             [matDatepicker]="dp1" [(ngModel)]="to_date" placeholder="To" [max]="today" (click)="dp1.open()" (dateChange)="checkdate2()" readonly />
      <mat-datepicker #dp1 (closed)="datereport()"></mat-datepicker>
      <payarc-date-clear [visible]="from_date || to_date" (cleared)="clearDates()"></payarc-date-clear>
    </div>
    <app-filter actions [filter_storage_key]="filter_storage_key" [count_storage_key]="count_storage_key" [filter]="filter"></app-filter>
    <button actions type="button" payarcButton="primary" (click)="exportexcel()">Export</button>
  </payarc-filter-bar>

  <payarc-section-card [flush]="true">
    <div class="pa-table-wrap">
      <payarc-table>
        <thead>
          <tr>
            <th [attr.aria-sort]="ariaSort(sortDirection('name'))">
              <button type="button" class="pa-th-sort" (click)="setSorting('name')">Name <payarc-sort-icon [direction]="sortDirection('name')"></payarc-sort-icon></button>
            </th>
            <th [attr.aria-sort]="ariaSort(sortDirection('email'))">
              <button type="button" class="pa-th-sort" (click)="setSorting('email')">Email address <payarc-sort-icon [direction]="sortDirection('email')"></payarc-sort-icon></button>
            </th>
            <th [attr.aria-sort]="ariaSort(sortDirection('desc'))">
              <button type="button" class="pa-th-sort" (click)="setSorting('desc')">Description <payarc-sort-icon [direction]="sortDirection('desc')"></payarc-sort-icon></button>
            </th>
            <th [attr.aria-sort]="ariaSort(sortDirection('created_at'))">
              <button type="button" class="pa-th-sort" (click)="setSorting('created_at')">Created on <payarc-sort-icon [direction]="sortDirection('created_at')"></payarc-sort-icon></button>
            </th>
            <th [attr.aria-sort]="ariaSort(sortDirection('card_type'))">
              <button type="button" class="pa-th-sort" (click)="setSorting('card_type')">Payment method <payarc-sort-icon [direction]="sortDirection('card_type')"></payarc-sort-icon></button>
            </th>
            <th>Customer ID</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="loadFlag">
            <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3,4,5]">
              <td *ngFor="let c of [1,2,3,4,5,6,7]"><span class="pa-skeleton-bar"></span></td>
            </tr>
          </ng-container>

          <tr *ngIf="!loadFlag && errorMsg">
            <td class="pa-table__state-cell" colspan="7">
              <payarc-empty-state [title]="hasLoadError ? 'Couldn\'t load customers' : 'No customers found'" [message]="errorMsg"></payarc-empty-state>
            </td>
          </tr>

          <ng-container *ngIf="!loadFlag && !errorMsg && customerList?.data?.length > 0">
            <tr class="cl-row" *ngFor="let customer of customerList.data" tabindex="0"
                [routerLink]="redirect_link" [queryParams]="{ id: customer.customer_id }"
                (keydown.enter)="$event.preventDefault(); openCustomerDetails(customer)">
              <td class="strong" [innerHTML]="highlight(customer.name)"></td>
              <td class="muted" [innerHTML]="highlight(customer.email)"></td>
              <td class="muted" [title]="nullToDoubleMinus(customer.description)" [innerHTML]="highlight(customer.description)"></td>
              <td class="muted" [title]="customer.created_at ? (customer.created_at | dateFormat : 'MM/dd/yyyy hh:mm') : '--'">
                {{customer.created_at ? (customer.created_at | dateFormat : 'MM/dd/yyyy hh:mm') : '--'}}
              </td>
              <td>
                <ng-container *ngIf="customer.defaultCard as card">
                  <span class="pa-card-cell">
                    <payarc-card-mark [width]="17" [brand]="card.brand"></payarc-card-mark>
                    <ng-container *ngIf="card.first6digit; else noFirst6">
                      <span [innerHTML]="highlight(card.first6digit | CreditCardMaskPipe)"></span>** ****
                    </ng-container>
                    <ng-template #noFirst6>**** **** ****</ng-template>
                    <span [innerHTML]="card.last4digit ? highlight(card.last4digit) : '****'"></span>
                  </span>
                </ng-container>
                <span class="pa-card-cell" *ngFor="let bank_account of customer.bank_account?.data">BA {{bank_account.account_number}}</span>
                <span class="muted" *ngIf="!customer.defaultCard && !(customer.bank_account?.data?.length > 0)">--</span>
              </td>
              <td class="muted" [innerHTML]="highlight(customer.customer_id)"></td>
              <td>
                <button type="button" class="pa-btn pa-btn--secondary cl-charge-btn" (click)="$event.stopPropagation(); $event.preventDefault(); chargeCustomer(customer)">Charge</button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </payarc-table>
    </div>

    <div class="cl-pager-row" *ngIf="!errorMsg && customerList?.meta?.pagination?.total">
      <label class="cl-pager-row__limit">
        Rows per page
        <select class="pa-input" [(ngModel)]="limit" (change)="limitChange()">
          <option *ngFor="let no of limitArray" [value]="no">{{ no }}</option>
        </select>
      </label>
      <payarc-pager
        [rangeLabel]="pagerRangeLabel"
        [pages]="pagerPages"
        [currentPage]="currentPage"
        [disablePrev]="currentPage <= 1"
        [disableNext]="currentPage >= totalPages"
        (prev)="pagerPrev()"
        (next)="pagerNext()"
        (pageSelect)="pagerSelect($event)"
      ></payarc-pager>
    </div>
  </payarc-section-card>
</ng-container>

<div *ngIf="showExport">
  <app-export-excel [exportExcel]="exportExcel" [serviceName]="exportData" [filterUrl]="filterPostFix" [searchData]="searchText"></app-export-excel>
</div>
